import { storage } from '@visiba/std';
import type { DebugConfig } from '@modules/debug_config';

export const devLocalStorage = storage<{
	config: DebugConfig.LocalStorageConfig;
	identitySession: string | null;
	requestVerificationToken: string | null;
	overrideFlags: Record<keyof ExpectedFlags, boolean> | null;
}>();
